<template>
    <section
        ref="section16"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="19"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <form
                method="POST"
                :action="routes.submitForm"
                id="select-extra-data-1"
                class="mx-auto w-full max-w-lg"
            >
                <v-csrf-token></v-csrf-token>
                <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                    <figure class="flex gap-3">
                        <div>
                            <v-icon icon="contract-edit" size="8"></v-icon>
                        </div>
                        <div class="flex flex-col justify-center">
                            <div class="mb-3 text-heading-3-desktop">
                                Dodatni podatki
                            </div>
                            <div class="text-body-regular text-black-40">
                                Izberete lahko več možnosti.
                            </div>
                        </div>
                    </figure>
                    <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4">
                        <li
                            class="col-span-4"
                            v-for="(
                                extra, onOfficeEnum
                            ) in stepData.extra_data_options"
                            :key="'extra-' + onOfficeEnum"
                        >
                            <v-checkbox
                                :id="onOfficeEnum"
                                :name="'extra_data[' + onOfficeEnum + ']'"
                                :label="stepData.labels[onOfficeEnum].label"
                                checkbox-position="right"
                                :value="onOfficeEnum"
                                :icon="extra.icon"
                                :checked="
                                    stepData.extra_data != null &&
                                    stepData.extra_data[onOfficeEnum]
                                "
                            ></v-checkbox>
                        </li>
                    </ul>
                </figure>
            </form>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-extra-data-1')"
                class="button button--md h-[48px] w-[240px] px-6"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {};
    },
    mounted() {},
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
